import API from './Api';

// Dashboard Image Imports
import ProceedingsLogo from '../assets/images/UserDashboard/Processing4.png'
import Approvals from '../assets/images/UserDashboard/Approval2.png'
import Attendance from '../assets/images/UserDashboard/Attendance.jpg'
import WorkComplete from '../assets/images/UserDashboard/WorkComplete.png'
import RTI from '../assets/images/UserDashboard/RTI.png'
import WorkNotStarted from '../assets/images/UserDashboard/WorkNotStarted.png'
import DroneVideo from '../assets/images/UserDashboard/DroneVideo.png'
import Voice from '../assets/images/UserDashboard/Voice22.png'
import Alert from '../assets/images/UserDashboard/Alert4.png'
import Accounts from '../assets/images/UserDashboard/Accounts1.png'
import News from '../assets/images/UserDashboard/news.png'
import Work from '../assets/images/UserDashboard/work2.jpg'
import PendingPayment from '../assets/images/UserDashboard/PendingPayment.png'
import Complaint from '../assets/images/UserDashboard/complaint.jpg'
import Construction from '../assets/images/UserDashboard/construction.jpg'

// Proceedings Image Imports                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
import AdminSanction from '../assets/images/Proceedings/AdminSanction.png';
import Agenda from '../assets/images/Proceedings/Agenda.png';
import AgreementProcess from '../assets/images/Proceedings/AgreementProcess.png';
import Committe from '../assets/images/Proceedings/Committe.png';
import Employees from '../assets/images/Proceedings/Employee.png';
import Meetings from '../assets/images/Proceedings/Meetings.png';
import Members from '../assets/images/Proceedings/Members.png';
import NegoationProcess from '../assets/images/Proceedings/NegoationProcess.png';
import PlanEstimate from '../assets/images/Proceedings/PlanEstimate.png';
import Resolutions from '../assets/images/Proceedings/Resolution.png';
import TechnicalSanction from '../assets/images/Proceedings/TechnicalSanction.png';
import TenderProcess from '../assets/images/Proceedings/TenderProcess.png';
import WorkOrder from '../assets/images/Proceedings/WorkOrderIcon.png';
import Back from '../assets/images/Proceedings/backicon.png';

// Attendance Image Import
import Calendar from '../assets/images/Attendance/calendar.png';

// Approval Images Imports

// import theoreticalSanction from '../assets/images/Approvals/theoreticalSanction.png';




// Define a map that links the Backend Boolean fields to the Dashboard Item titles
const ACCESS_MAP = {
  proceedings: 'Proceedings',
  approvals: 'Approvals',
  attendance: 'Attendance',
  complaints: 'Complaints',
  rti: 'RTI',
  work: 'Work',
  workNotStarted: 'Work Not Started',
  workCompleted: 'Works Completed',
  accounts: 'Accounts',
  pendingPayment: 'Pending Payment',
  sitePictures: 'Site Pictures',
  voice: 'Voice',
  droneVideo: 'Drone Video',
  alert: 'Alert',
  news: 'News',
  statistics: 'Statistics' // Added based on your EmployeeMenuAccess entity
};

export const getDashboardItems = async (accessData, user) => {
  const allItems = [
    { image: ProceedingsLogo, title: 'Proceedings', translationKey: 'dashboard.proceedings', link: '/smartcity/proceedings', key: 'proceedings' },
    { image: Approvals, title: 'Approvals', translationKey: 'dashboard.approvals', link: '/smartcity/approvals', key: 'approvals' },
    { image: Attendance, title: 'Attendance', translationKey: 'dashboard.attendance', link: '/smartcity/attendance', key: 'attendance' },
    { image: Complaint, title: 'Complaints', translationKey: 'dashboard.complaints', link: '/smartcity/complaints', key: 'complaints' },
    { image: RTI, title: 'RTI', translationKey: 'dashboard.rti', link: '/smartcity/rti', key: 'rti' },
    { image: Work, title: 'Work', translationKey: 'dashboard.work', link: '/smartcity/works', key: 'work' },
    { image: WorkNotStarted, title: 'Work Not Started', translationKey: 'dashboard.workNotStarted', link: '/smartcity/works-not-started', key: 'workNotStarted' },
    { image: WorkComplete, title: 'Works Completed', translationKey: 'dashboard.workCompleted', link: '/smartcity/works-completion', key: 'workCompleted' },
    { image: Accounts, title: 'Accounts', translationKey: 'dashboard.accounts', link: '/smartcity/accounts', key: 'accounts' },
    { image: PendingPayment, title: 'Pending Payment', translationKey: 'dashboard.pendingPayment', link: '/smartcity/pendingPayment', key: 'pendingPayment' },
    { image: Construction, title: 'Site Pictures', translationKey: 'dashboard.sitePictures', link: '/smartcity/visit-sites', key: 'sitePictures' },
    { image: Voice, title: 'Voice', translationKey: 'dashboard.voice', link: '/smartcity/voice', key: 'voice' },
    { image: DroneVideo, title: 'Drone Video', translationKey: 'dashboard.droneVideo', link: '/smartcity/video', key: 'droneVideo' },
    { image: Alert, title: 'Alert', translationKey: 'dashboard.alert', link: '/smartcity/staff-alerts', key: 'alert' },
    {
      image: News,
      title: 'News',
      translationKey: 'dashboard.news',
      //  DYNAMIC LINK LOGIC START
      link: (user?.department === 'ADMINISTRATION' && user?.designation === 'Junior Officer')
        ? '/smartcity/news/details'
        : '/smartcity/news',
      //  DYNAMIC LINK LOGIC END
      key: 'news'
    }
  ];

  // If no accessData is provided (e.g., Admin user), grant access to all
  if (!accessData) {
    return allItems.map(item => ({ ...item, hasAccess: true }));
  }

  // Map items to include hasAccess boolean instead of filtering
  return allItems.map(item => ({
    ...item,
    hasAccess: accessData[item.key] === true
  }));
};


export const getProceedingsItems = async () => {
  // Replace with real API call
  return [
    { image: Members, title: 'Members', translationKey: 'proceedings.members', link: '/smartcity/proceedings/members', countKey: 'members' },
    { image: Employees, title: 'Employees', translationKey: 'proceedings.employees', link: '/smartcity/proceedings/employees', countKey: 'employees' },
    { image: Committe, title: 'Committee', translationKey: 'proceedings.committee', link: '/smartcity/proceedings/committee', countKey: 'committee' },
    { image: Meetings, title: 'Meetings', translationKey: 'proceedings.meetings', link: '/smartcity/proceedings/meetings', countKey: 'meetings' },
    { image: Agenda, title: 'Agenda', translationKey: 'proceedings.agenda', link: '/smartcity/proceedings/agendas', countKey: 'agenda' },
    { image: Resolutions, title: 'Resolutions', translationKey: 'proceedings.resolutions', link: '/smartcity/proceedings/resolutions', countKey: 'resolutions' },
    { image: PlanEstimate, title: 'Plan Estimate', translationKey: 'proceedings.planEstimate', link: '/smartcity/proceedings/plan-estimates', countKey: 'planEstimate' },
    { image: AdminSanction, title: 'Admin Sanction', translationKey: 'proceedings.adminSanction', link: '/smartcity/proceedings/admin-sanctions', countKey: 'adminSanction' },
    { image: TechnicalSanction, title: 'Technical Sanction', translationKey: 'proceedings.technicalSanction', link: '/smartcity/proceedings/technical-sanctions', countKey: 'technicalSanction' },
    { image: TenderProcess, title: 'Tender Process', translationKey: 'proceedings.tenderProcess', link: '/smartcity/proceedings/tender-process', countKey: 'tenderProcess' },
    { image: NegoationProcess, title: 'Negotiation Process', translationKey: 'proceedings.negotiationProcess', link: '/smartcity/proceedings/negotiation-process', countKey: 'negotiationProcess' },
    { image: AgreementProcess, title: 'Aggreement Process', translationKey: 'proceedings.agreementProcess', link: '/smartcity/proceedings/aggreement-process', countKey: 'agreementProcess' },
    { image: WorkOrder, title: 'Work Order', translationKey: 'proceedings.workOrder', link: '/smartcity/proceedings/work-order', countKey: 'workOrder' },
    { image: Back, title: 'Back', translationKey: 'proceedings.back', link: '/SmartCity/dashboard', countKey: null },
  ];
};

export const getApprovalsItems = async () => {
  // Replace with real API call
  return [
    {
      image: PlanEstimate,
      title: 'Plan Estimate',
      translationKey: 'approvals.approvePlanEstimate',
      link: '/smartcity/approvals/plan-estimates'
    },
    {
      image: Members,
      title: 'Theoretical Sanction',
      translationKey: 'approvals.theoreticalSanction',
      link: '/smartcity/approvals/theoretical-sanctions'
    },
    {
      image: AdminSanction,
      title: 'Admin Sanction',
      translationKey: 'approvals.approveAdminSanction',
      link: '/smartcity/approvals/admin-sanctions'
    },
    {
      image: TechnicalSanction,
      title: 'Technical Sanction',
      translationKey: 'approvals.approveTechnicalSanction',
      link: '/smartcity/approvals/technical-sanctions'
    },
    {
      image: TenderProcess,
      title: 'Tender Process',
      translationKey: 'approvals.approveTenderProcess',
      link: '/smartcity/approvals/tender-process'
    },
    {
      image: NegoationProcess,
      title: 'Negotiation Process',
      translationKey: 'approvals.approveNegotiationProcess',
      link: '/smartcity/approvals/negotiation-process'
    },
    {
      image: AgreementProcess,
      title: 'Aggreement Process',
      translationKey: 'approvals.approveAgreementProcess',
      link: '/smartcity/approvals/agreement-process'
    },
    {
      image: WorkOrder,
      title: 'Work Order',
      translationKey: 'approvals.approveWorkOrder',
      link: '/smartcity/approvals/work-order'
    },
    {
      image: Back,
      title: 'Back',
      translationKey: 'proceedings.back',
      link: '/smartcity/dashboard'
    },
  ];
};

export const getAccountsItems = async () => {
  // Replace with real API call
  return [
    {
      image: Members,
      title: 'Budget Head',
      translationKey: 'accounts.budgetHeadMenu',
      link: '/smartcity/accounts/budget-head'
    },
    {
      image: Committe,
      title: 'Payment',
      translationKey: 'accounts.paymentMenu',
      link: '/smartcity/accounts/payment'
    },
    {
      image: Back,
      title: 'Back',
      translationKey: 'proceedings.back',
      link: '/smartcity/dashboard'
    },
  ];
};

export const getAttendanceItems = async (user) => {
  // Replace with real API call
  const allItems = [
    {
      image: Members,
      title: 'Mark Attendance',
      translationKey: 'attendance.markAttendance',
      link: '/smartcity/attendance/mark-attendance',
      requiredDepartment: ['Gen Admin'],
      requiredDesignations: ['Junior Clerk', 'Senior Clerk']
    },
    {
      image: Calendar,
      title: 'Daily Attendace',
      translationKey: 'attendance.dailyAttendance',
      link: '/smartcity/attendance/daily-attendance'
    },
    {
      image: Employees,
      title: 'Attendance Summary',
      translationKey: 'attendance.attendanceSummary',
      link: '/smartcity/attendance/attendance-summary'
    },
    {
      image: Back,
      title: 'Back',
      translationKey: 'attendance.back',
      link: '/smartcity/dashboard'
    },
  ];

  return allItems.filter(item => {
    if (!item.requiredDesignations) return true;

    return item.requiredDesignations.includes(user?.designation);
  })
};


export const getProceedingCounts = async () => {
  const { data } = await API.get("/staff-proceedings-counts");
  return data.data;
};


// API to get genders

export const getGenders = async () => {
  const { data } = await API.get("/genders");
  return data;
}

// API to get wards

export const getAllWardsForUser = async () => {
  const res = await API.get("/admin/wards/all");
  return res.data.data;
};

// Staff Members Services

export const createMember = async (formData) => {
  const { data } = await API.post("/members/create", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data.data;
};

export const getMembers = async (q = "", page = 0, size = 10) => {
  const { data } = await API.get("/members", { params: { q, page, size } });
  return data.data;
};


export const getMemberById = async (id) => {
  const { data } = await API.get(`/members/${id}`);
  return data.data;
};

export const getAllMembers = async () => {
  const { data } = await API.get("/members/getAll");
  return data;
};

export const updateMember = async (id, finalFormData) => {
  const { data } = await API.put(`/members/update/${id}`, finalFormData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data.data;
};

export const getActiveMembers = async () => {
  const { data } = await API.get("/members/active");
  return data;
};


// Staff Employee Service

export const createStaffEmployee = async (finalFormData) => {
  const { data } = await API.post(`/staff-employees/add`, finalFormData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};

export const updateStaffEmployee = async (id, finalFormData) => {
  const { data } = await API.put(`/staff-employees/update/${id}`, finalFormData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};

export const getStaffEmployees = async (q = "", page = 0, size = 10) => {
  const { data } = await API.get("/staff-employees/get-all-search", { params: { q, page, size } });
  return data.data;
};


export const getAllStaffEmployees = async () => {
  const { data } = await API.get(`/staff-employees/all`);
  return data; // Returns the ApiResponse wrapper
};


export const getActiveStaffEmployees = async () => {
  const { data } = await API.get(`/staff-employees/active`);
  return data;
};



// Staff Committee Service 

export const createStaffCommittee = async (payload) => {
  const { data } = await API.post(`/staff-committee/add`, payload);
  return data;
}

export const updateStaffCommittee = async (id, payload) => {
  const { data } = await API.put(`/staff-committee/update/${id}`, payload);
  return data;
}

export const getStaffCommittees = async (q = "", page = 0, size = 10) => {
  const { data } = await API.get("/staff-committee/get-all-search", { params: { q, page, size } });
  return data.data;
}

export const getAllActiveStaffCommittees = async () => {
  const { data } = await API.get(`/staff-committee/active`);
  return data;
};

export const getAllActiveCommitteesForStaff = async () => {
  const { data } = await API.get(`/staff-committee/active-committees`);
  return data;
};


// Staff Meeting Service

export const createStaffMeeting = async (formData) => {
  const { data } = await API.post("/staff-meetings/add", formData);
  return data.data;
}

export const updateStaffMeeting = async (id, formData) => {
  const { data } = await API.put(`/staff-meetings/update/${id}`, formData);
  return data.data;
}


export const getStaffMeetings = async (q = "", page = 0, size = 10) => {
  const { data } = await API.get("/staff-meetings/get-all-search", { params: { q, page, size } });
  return data.data;
}

export const getAllActiveStaffMeetings = async () => {
  const { data } = await API.get(`/staff-meetings/active`);
  return data.data;
};


// Staff Agendas Services

export const createStaffAgenda = async (payload) => {
  // Do NOT wrap payload in an object like { payload }. Send it directly.
  const { data } = await API.post("/staff-agendas/add", payload, {
    headers: { "Content-Type": "multipart/form-data" } // explicitly tell axios
  });
  return data.data;
};

export const updateStaffAgenda = async (meetingId, payload) => {
  const { data } = await API.put(`/staff-agendas/update/${meetingId}`, payload, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data.data;
};

export const getStaffAgendas = async (q = "", page = 0, size = 10) => {
  const { data } = await API.get("/staff-agendas/get-all-search", { params: { q, page, size } });
  return data.data;
};

export const getAllActiveStaffAgendas = async () => {
  const { data } = await API.get(`/staff-agendas/active`);
  return data;
};

// Staff Resolution Service

export const createStaffResolution = async (payload) => {
  const { data } = await API.post("/staff-resolutions/add", payload, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data.data;
}

export const updateStaffResolution = async (meetingId, payload) => {
  const { data } = await API.put(`/staff-resolutions/update/${meetingId}`, payload, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data.data;;
};

export const getStaffResolutions = async (q = "", page = 0, size = 10) => {
  const { data } = await API.get("/staff-resolutions/get-all-search", { params: { q, page, size } });
  return data.data;
};

// Staff Plan Estimate Service

export const createStaffPlanEstimate = async (payload) => {
  const { data } = await API.post("/staff-plan-estimates/add", payload, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data.data;
};

export const updateStaffPlanEstimate = async (id, payload) => {
  const { data } = await API.put(`/staff-plan-estimates/update/${id}`, payload, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data.data;
};

export const getStaffPlanEstimates = async (q = "", page = 0, size = 10) => {
  const { data } = await API.get("/staff-plan-estimates/get-all-search", {
    params: { q, page, size }
  });
  return data.data;
};




// Admin Sanctions Service

export const getAdminSanctionsWork = async (q = "", page = 0, size = 10) => {
  const { data } = await API.get("/getAdminSanctionWorks", {
    params: { q, page, size }
  });
  return data.data;
};

export const getEstimatesByWorkType = async (workTypeId, page = 0, size = 10) => {
  const { data } = await API.get(`/staff-plan-estimates/by-work-type/${workTypeId}`, {
    params: { page, size }
  });
  return data.data;
};

export const sanctionPlanEstimate = async (id, payload) => {
  const { data } = await API.patch(`/staff-plan-estimates/sanction/${id}`, payload, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data.data;
};


// Technical Sanctions


export const getTechnicalSanctionsWork = async (q = "", page = 0, size = 10) => {
  const { data } = await API.get("/getTechnicalSanctionWorks", {
    params: { q, page, size }
  });
  return data.data;
};

export const getAdminSanctionedPlanEstimates = async (workTypeId, page = 0, size = 10) => {
  const { data } = await API.get(`/staff-plan-estimates/admin-sanctioned/${workTypeId}`, {
    params: { page, size }
  });
  return data.data;
};

export const technicalSanctionPlanEstimate = async (id, payload) => {
  const { data } = await API.patch(`/staff-plan-estimates/technical-sanction/${id}`, payload, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data.data;
};


// Tender Process

export const getTenderProcessList = async (q = "", page = 0, size = 10) => {
  const { data } = await API.get("/tender-process/list", {
    params: { q, page, size }
  });
  return data.data;
};


export const createTenderProcess = async (formData) => {
  const { data } = await API.post("/tender-process/add", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data.data;
};


export const updateTenderProcess = async (id, formData) => {
  const { data } = await API.put(`/tender-process/update/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data.data;
};


// Negotiation Process


export const getNegotiationList = async (q = "", page = 0, size = 10) => {
  const { data } = await API.get("/negotiation/list", {
    params: { q, page, size }
  });
  return data.data;
};


export const createNegotiation = async (payload) => {
  const { data } = await API.post("/negotiation/add", payload);
  return data.data;
};


export const updateNegotiation = async (id, payload) => {
  const { data } = await API.put(`/negotiation/update/${id}`, payload);
  return data.data;
};


//  Aggreement Process

export const getAgreementList = async (q = "", page = 0, size = 10) => {
  const { data } = await API.get("/staff-agreement/list", {
    params: { q, page, size }
  });
  return data.data;
};

export const createAgreement = async (payload) => {
  const { data } = await API.post("/staff-agreement/add", payload);
  return data.data;
};

export const updateAgreement = async (id, payload) => {
  const { data } = await API.put(`/staff-agreement/update/${id}`, payload);
  return data.data;
};


// Work Order

export const getWorkOrderList = async (q = "", page = 0, size = 10) => {
  const { data } = await API.get("/staff-work-order/list", {
    params: { q, page, size }
  });
  return data.data;
};

// get approved work order
// export const getApprovedWorkOrderList = async (q = "", page = 0, size = 10) => {
//   const { data } = await API.get("/staff-work-order/approved-list", {
//     params: { q, page, size }
//   });
//   return data.data;
// };

export const getApprovedWorksByType = async (workTypeId, q = "", page = 0, size = 10) => {
  // Use a template literal to inject the ID into the URL path
  const { data } = await API.get(`/staff-work-order/approved-by-work-type/${workTypeId}`, {
    params: { q, page, size } // searchTerm and pagination stay as query params
  });
  return data.data;
};


export const createWorkOrder = async (payload) => {
  const { data } = await API.post("/staff-work-order/add", payload);
  return data.data;
};


export const updateWorkOrder = async (id, payload) => {
  const { data } = await API.put(`/staff-work-order/update/${id}`, payload);
  return data.data;
};


// Approval Section -> Plan Estimate and Theoretical Approval

export const approveFinalPlanEstimate = async (id, remark) => {
  const { data } = await API.patch(`/staff-plan-estimates/approve-final/${id}`, null, {
    params: { remark }
  });
  return data.data;
};

// Approvals -> Theoretical Approval
export const getReadyForTheoreticalSanctionList = async (q = '', page = 0, size = 10) => {
  const { data } = await API.get("/staff-plan-estimates/getApproved", {
    params: { q, page, size }
  });
  return data.data;
};

// Approvals -> Theoretical Approval -> Add Approval
export const approveTheoreticalPlan = async (id, remark) => {
  const { data } = await API.patch(`/staff-plan-estimates/approve-theoretical/${id}`, null, {
    params: { remark }
  });
  return data.data;
};


// Approvals -> Admin Sanction
export const getAdminSanctionApprovedList = async (q = '', page = 0, size = 10) => {
  const { data } = await API.get("/staff-plan-estimates/getAdminSanctionApproved", {
    params: { q, page, size }
  });
  return data.data;
};



// Approvals -> Admin Sanction -> Admin Approval

export const approveAdminSanction = async (id, remark) => {
  const { data } = await API.patch(`/staff-plan-estimates/approve-admin/${id}`, null, {
    params: { remark }
  });
  return data.data;
};


// Approvals -> Technical Sanction
export const getTechnicalApprovalList = async (q = '', page = 0, size = 10) => {
  const { data } = await API.get("/staff-plan-estimates/getTechnicalApprovalList", {
    params: { q, page, size }
  });
  return data.data;
};

// Approvals -> Technical Sanction -> Technical Approval
export const approveTechnicalSanction = async (id, remark) => {
  const { data } = await API.patch(`/staff-plan-estimates/approve-technical/${id}`, null, {
    params: { remark }
  });
  return data.data;
};


// Approvals -> Tender Process 

export const approveTenderProcess = async (id, remark) => {
  const { data } = await API.post(`/tender-process/approve/${id}`, null, {
    params: { remark }
  });
  return data.data;
};

export const getApprovedTenderList = async (page = 0, size = 10) => {
  const { data } = await API.get("/tender-process/approved-list", {
    params: { page, size }
  });
  return data.data;
};


// Approvals -> Negotiation Process

export const getNegotiationApprovalList = async (q = '', page = 0, size = 10) => {
  const { data } = await API.get("/negotiation/approval-list", { params: { q, page, size } });
  return data.data;
};

export const approveNegotiationAction = async (id, remark) => {
  const { data } = await API.post(`/negotiation/approve/${id}`, null, { params: { remark } });
  return data.data;
};

// Approvals -> Agreement Process

export const getAgreementApprovalList = async (q = '', page = 0, size = 10) => {
  const { data } = await API.get("/staff-agreement/approval-list", { params: { q, page, size } });
  return data.data;
};

export const approveAgreementAction = async (id, remark) => {
  const { data } = await API.post(`/staff-agreement/approve/${id}`, null, { params: { remark } });
  return data.data;
};

// Approvals -> Work Order

export const getWorkOrderApprovalList = async (q = '', page = 0, size = 10) => {
  const { data } = await API.get("/staff-work-order/approval-list", {
    params: { q, page, size }
  });
  return data.data;
};


export const approveWorkOrderAction = async (id, remark) => {
  const { data } = await API.post(`/staff-work-order/approve/${id}`, null, {
    params: { remark }
  });
  return data.data;
};


// Attendance Section

export const getEmployeesForAttendance = async (deptId, date) => {
  const { data } = await API.get("staff-attendance/list", {
    params: {
      departmentId: deptId === "All" ? null : deptId,
      date
    }
  });
  return data.data;
}

export const saveBulkAttendanceAction = async (payload) => {
  const { data } = await API.post("/staff-attendance/save", payload);
  return data;
};

export const getDailyAttendanceSummary = async (date) => {
  const { data } = await API.get("/staff-attendance/summary", {
    params: { date }
  });
  return data.data;
};

export const getEmployeesByStatus = async (date, statusId) => {
  const { data } = await API.get("/staff-attendance/by-status", {
    params: { date, statusId }
  });
  return data.data;
};

export const getAttendanceDetailsByType = async (date, type) => {
  const { data } = await API.get("/staff-attendance/details-by-type", {
    params: { date, type }
  });
  return data.data;
};

export const getAttendanceSummaryRange = async (fromDate, toDate, deptId) => {
  const { data } = await API.get("/staff-attendance/summary-date-range", {
    params: {
      fromDate,
      toDate,
      departmentId: deptId === "All" ? null : deptId
    }
  });
  return data.data;
};



// Complaints Section Services

export const getAllComplaints = async (params) => {
  const { data } = await API.get("/staff-complaints/getAll", { params });
  return data.data;
};


export const addComplaint = async (payload) => {
  const { data } = await API.post("/staff-complaints/add", payload, {
    headers: { "Content-Type": "multipart/form-data" }, // Required for file uploads
  });
  return data;
};


export const updateComplaint = async (id, payload) => {
  const { data } = await API.put(`/staff-complaints/update/${id}`, payload, {
    headers: { "Content-Type": "multipart/form-data" }, // Required for file uploads
  });
  return data;
};


export const downloadComplaintFile = (fileUrl) => {
  if (!fileUrl) return;
  // Construct the absolute URL for the backend download endpoint
  const fullUrl = `${process.env.REACT_APP_API_URL}/staff-complaints/download?fileUrl=${encodeURIComponent(fileUrl)}`;
  window.open(fullUrl, '_blank');
};

// RTI Services

export const getAllRti = async (params) => {
  const { data } = await API.get("/rti/getAll", { params });
  return data.data;
}

export const getRtiById = async (id) => {
  const { data } = await API.get(`/rti/getById/${id}`);
  return data.data;
}

export const addRti = async (payload) => {
  const { data } = await API.post("/rti/add", payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export const updateRti = async (id, payload) => {
  const { data } = await API.put(`/rti/update/${id}`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export const downloadRtiFile = (fileUrl) => {
  if (!fileUrl) return;
  const fullUrl = `${process.env.REACT_APP_API_URL}/rti/download?fileUrl=${encodeURIComponent(fileUrl)}`;
  window.open(fullUrl, '_blank');
};

// Works Section

export const getWorksByWorkOrderId = async (workOrderId) => {
  const { data } = await API.get(`/work/getByWorkOrderId/${workOrderId}`);
  return data.data;
};

export const addWork = async (payload) => {
  const { data } = await API.post("/work/add", payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const updateWork = async (id, payload) => {
  const { data } = await API.put(`/work/update/${id}`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

//  for counts of approved work order of work types.
export const getApprovedWorkTypeCounts = async (q = "", page = 0, size = 10) => {
  const { data } = await API.get("/staff-work-order/work-type-counts", {
    params: { q, page, size }
  });
  return data.data;
};


export const getWorkOrderById = async (id) => {
  const { data } = await API.get(`/staff-work-order/getById/${id}`);
  return data.data; // Returns the single Work Order object
};

// Works Completed Section

export const markWorkAsCompleted = async (id, payload) => {
  const { data } = await API.put(`/staff-work-order/mark-completed/${id}`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};


// Accounts Section

export const getBudgetHeads = async (q = "", page = 0, size = 10) => {
  const { data } = await API.get('/budget-head/getAllBudgetHeads', {
    params: { q, page, size }
  });
  return data.data;
};

export const getBudgetHeadDropdown = async () => {
  const { data } = await API.get('/budget-head/getAllBudgetHeads', { params: { size: 1000 } });
  return data.data;
};

export const addBudgetHead = async (payload) => {
  const { data } = await API.post('/budget-head/add', payload);
  return data;
};


export const getPaymentsByWorkOrder = async (workOrderId) => {
  const { data } = await API.get(`/payment/by-work-order/${workOrderId}`);
  return data.data;
};

export const addWorkPayment = async (payload) => {
  const { data } = await API.post('/payment/add', payload, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data;
};

// Visit Sites Pictures

export const uploadSitePicture = async (workOrderId, file, onUploadProgress) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await API.post(
    `/site-pictures/upload/${workOrderId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress: (progressEvent) => {
        if (onUploadProgress && progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onUploadProgress(percentCompleted);
        }
      }
    }
  );

  return response.data?.data;
};

export const getSitePictures = async (workOrderId) => {
  const response = await API.get(`/site-pictures/list/${workOrderId}`);
  return response.data?.data || [];
};

export const toggleSitePicture = async (id) => {
  const response = await API.put(`/site-pictures/toggle/${id}`);
  return response.data;
};

// Voice Section

export const uploadVoice = async (workOrderId, file, onUploadProgress) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await API.post(
    `/voice/upload/${workOrderId}`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (progressEvent) => {
        if (onUploadProgress && progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onUploadProgress(percentCompleted);
        }
      }
    }
  );

  return res.data?.data;
};

export const getVoices = async (workOrderId) => {
  const res = await API.get(`/voice/list/${workOrderId}`);
  return res.data?.data;
};

export const toggleVoice = async (id) => {
  await API.put(`/voice/toggle/${id}`);
};


// Video Section

export const uploadVideo = async (workOrderId, file, onUploadProgress) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await API.post(`/video/upload/${workOrderId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (progressEvent) => {
      if (onUploadProgress && progressEvent.total) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onUploadProgress(percentCompleted);
      }
    }
  });

  return res.data?.data;
};

export const getVideos = async (workOrderId) => {
  const res = await API.get(`/video/list/${workOrderId}`);
  return res.data?.data;
};

export const toggleVideo = async (id) => {
  await API.put(`/video/toggle/${id}`);
};

// Staff Alert Type

export const getAllStaffAlerts = async () => {
  const res = await API.get("/alert-type/getAll")
  return res.data?.data;
}

export const getAlertCounts = async () => {
  const data = await API.get("/budget-head/counts");
  return data;
};

// export const getAlertCounts = async () => {
//   const res = await API.get("/payment/counts");
//   return res.data;
// };

export const getAlertDetails = async (type, page = 0, size = 10) => {
  const res = await API.get("/budget-head/details", {
    params: {
      type,
      page,
      size,
    },
  });

  return res.data;
};


export const getPaymentsByBudgetHead = async (budgetHeadId, page = 0, size = 10) => {
  try {
    const res = await API.get(`/payment/by-budget-head/${budgetHeadId}`, {
      params: { page, size }
    });
    return res.data?.data;
  } catch (error) {
    console.error("API Error in getPaymentsByBudgetHead:", error);
    throw error;
  }
};


// RTI Alert Services
export const getCombinedAlertCounts = async () => {
  const res = await API.get("/alerts/combined-counts");
  return res.data;
};

export const getRtiAlertDetails = async (type, page = 0, size = 10) => {
  const res = await API.get("/alerts/details", {
    params: { type, page, size },
  });
  return res.data?.data;
};

// For Issued Work Copletion details
export const getCompletionAlertDetails = async (page = 0, size = 10) => {
  const res = await API.get("/alerts/works/completion-details", {
    params: { page, size },
  });
  return res.data?.data;
};

export const getOutOfTimelineDetails = async (page = 0, size = 10) => {
  const res = await API.get("/alerts/works/out-of-timeline-details", {
    params: { page, size },
  });
  return res.data?.data;
};


// New Section

export const uploadNews = async (newsData, file, onUploadProgress) => {
  const formData = new FormData();

  formData.append("data", new Blob([JSON.stringify(newsData)], {
    type: "application/json"
  }));

  formData.append("file", file);

  const res = await API.post("/news/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (progressEvent) => {
      if (onUploadProgress && progressEvent.total) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onUploadProgress(percentCompleted);
      }
    }
  });
  return res.data?.data;
};


export const getNewsList = async (page = 0, size = 10) => {
  const res = await API.get("/news/list", {
    params: { page, size },
  });
  return res.data?.data; // Returns the Page object
};

export const searchNews = async (query, page = 0, size = 10) => {
  const res = await API.get("/news/search", {
    params: { q: query, page, size },
  });
  return res.data?.data;
};

export const toggleNewsStatus = async (id) => {
  const res = await API.put(`/news/toggle/${id}`);
  return res.data?.data;
};
